// extracted by mini-css-extract-plugin
export var closeButton = "_x-5";
export var container = "_x-0";
export var contentContainer = "_x-1";
export var desktop = "_x-2";
export var fullModalImage = "_x-6";
export var mobile = "_x-3";
export var withImage = "_x-4";